import axios from "axios";
import * as actionTypes from "./actionTypes";

export const initPutRequestedInfo = () => {
  return {
    type: actionTypes.INIT_PUT_REQUIRED_INFO,
    updtaing: true,
  };
};

export const successPutRequestedInfo = () => {
  return {
    type: actionTypes.SUCCESS_PUT_REQUIRED_INFO,
    updtaing: false,
    hasInfo: true,
  };
};

export const failPutRequestedInfo = (error) => {
  return {
    type: actionTypes.FAIL_PUT_REQUIRED_INFO,
    updtaing: false,
    error: error,
  };
};

export const putRquestedInfo = (data, addressData) => {
  const config = {
    headers: {
      Authorization: "Bearer " + localStorage.getItem("idToken"),
    },
  };
  return (dispatch) => {
    dispatch(initPutRequestedInfo());
    axios
      .put("users/me", data, config)
      .then((response) => {
        console.log(response.data);
      })
      .catch((error) => {
        console.log(error.message);
      });
    axios
      .get("addresses", config)
      .then((response) => {
        // console.log(response.data.data);
        const id = response.data.data[0].id;
        // console.log(response.data, id);
        axios
          .put(`addresses/${id}`, addressData, config)
          .then((response) => {
            // console.log(response.data);
            dispatch(successPutRequestedInfo());
          })
          .catch((error) => {
            console.log(error.message);
          });
      })
      .catch((error) => {
        console.log(error.message);
        dispatch(failPutRequestedInfo(error.message));
      });
  };
};
